import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@fortawesome/fontawesome-free/svgs/solid/plus.svg'


const _hoisted_1 = { class: "add-location-form" }
const _hoisted_2 = { class: "add-location-form__suggestions" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "add-location-form__suggestion-name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon icon_small icon_transparent",
  alt: "Add"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "search",
      class: "add-location-form__input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.locationName) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getTipsDebounced && _ctx.getTipsDebounced(...args)))
    }, null, 544), [
      [_vModelText, _ctx.locationName]
    ]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationSuggestions, (locationTip, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "add-location-form__suggestion",
          key: index,
          onClick: ($event: any) => (_ctx.addLocation(locationTip))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(locationTip.name), 1),
          _hoisted_5
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}